import { render, staticRenderFns } from "./TransIm.vue?vue&type=template&id=003efa8b&scoped=true"
import script from "./TransIm.vue?vue&type=script&lang=js"
export * from "./TransIm.vue?vue&type=script&lang=js"
import style0 from "./TransIm.vue?vue&type=style&index=0&id=003efa8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003efa8b",
  null
  
)

export default component.exports